import React from 'react';
import { Link } from 'react-router-dom';
import { TourPopupLink } from '../components/TourPopupLink';
export function Shop() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-258" data-mp="3iy8e3jufhtq8">
      {/* Header — matches the other pages */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-259" data-mp="34ax2xj25sbqn">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-260" data-mp="2zbkamisiqcgo">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-261" data-mp="3e0qh8rtor4yl">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-262" data-mp="398ypwf2pgv7e">
            catalog
          </Link>
          <TourPopupLink data-id="element-263" data-mp="2lj4cnweh54mm" />
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-264" data-mp="2limakj54rw6s">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-265" data-mp="2gj9lrsup8f1k">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-266" data-mp="3djs566dm606w">
          contact
        </a>
      </header>

      {/* Shop content */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-267" data-mp="3nbef7ze7tt82">
        <p className="lowercase" data-id="element-268" data-mp="3rbyep9m9h8xd">under maintenance</p>
      </section>
    </main>;
}